import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SubmittalsPage } from '@/features/resources/submittals-page';

const searchSchema = z.object({ submittal: z.string().optional().catch(undefined) });

export const Route = createFileRoute('/_app/projects/$projectId/resources/submittals')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <SubmittalsPage projectId={projectId} submittalId={search.submittal} />;
}
